module.exports = __webpack_public_path__ + "static/img/1-1Z60413434YB.de94685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z60413434YB.jpg
// module id = SbV3
// module chunks = 0